export default __webpack_public_path__ + "static/media/photo2.e48561ad.webp";